function NRArrowForwardIcon({ height = '20', width = '20', color = 'black' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="arrow_forward_icon">
        <path
          id="Vector"
          d="M10.0002 3.3335L8.82516 4.5085L13.4752 9.16683H3.3335V10.8335H13.4752L8.82516 15.4918L10.0002 16.6668L16.6668 10.0002L10.0002 3.3335Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default NRArrowForwardIcon;
